export type SectionTableSearchHighlightPart = {
  text: string;
  match: boolean;
};

export function splitSectionTableSearchHighlight(text: string, query: string): SectionTableSearchHighlightPart[] {
  const needle = query.trim();

  if (!needle || !text) {
    return [{ text, match: false }];
  }

  const lowerText = text.toLowerCase();
  const lowerNeedle = needle.toLowerCase();
  const parts: SectionTableSearchHighlightPart[] = [];
  let start = 0;

  while (start < text.length) {
    const index = lowerText.indexOf(lowerNeedle, start);

    if (index < 0) {
      parts.push({ text: text.slice(start), match: false });
      break;
    }

    if (index > start) {
      parts.push({ text: text.slice(start, index), match: false });
    }

    parts.push({ text: text.slice(index, index + needle.length), match: true });
    start = index + needle.length;
  }

  return parts.filter((part) => part.text);
}
